import SwivuWelcomeModal from "./SwivuWelcomeModal.jsx";

const SwivuHomeInfo = ({
  loggedInAsEmail,
  loggedInUserProfileImage,
  onContinueBoard,
  welcomeModalData,
}) => {
  return (
    <>
      <p className="my-0 mt-3 text-base font-bold text-[#61646b]">
        Logged in as:
      </p>
      <div className="flex items-center gap-2 mb-4">
        {loggedInUserProfileImage && (
          <img
            src={loggedInUserProfileImage}
            className="mx-auto w-10 rounded-full"
            alt="User Avatar"
          />
        )}
        <p className="text-base text-[#ffa500]">{loggedInAsEmail}</p>
      </div>
      <SwivuWelcomeModal isDisplayCheck={false} onContinueBoard={onContinueBoard} btnText={`Continue to:  "${welcomeModalData.selectedBoard.name}"`} />
    </>
  )
}

export default SwivuHomeInfo;